import qs from "qs";
import requestSC from "@/utils/requestSC";

// 发送验证码
export async function generateCaptcha(params = {}) {
  return requestSC.post("/servlet/auth/generateCaptcha", qs.stringify(params));
}

// 校验验证码
export async function checkCaptcha(params = {}) {
  return requestSC.post("/servlet/auth/checkCaptcha", qs.stringify(params));
}

// 业务线提交--校验验证码
export async function submitCaptcha(params = {}) {
  return requestSC.post("/servlet/auth/submitCaptcha", qs.stringify(params));
}

// 删除验证码
export async function delCaptcha(params = {}) {
  return requestSC.post("/servlet/auth/delCaptcha", qs.stringify(params));
}
